export const LEAD_DROP_POPUP_4_CONSTANTS = {
  DEFAULT_ROW: {
    form_title: "",
    form_title_color: "#000000",
    form_sub_text: "",
    form_sub_text_color: "#666666",
    checkbox_description: "",
    checkbox_description_color: "#666666",
    checkbox_color: "#BE2330",
    button_color: "#BE2330",
    button_text_color: "#FFFFFF",
    signup_button_text: "Sign Up",
    signup_icon: "",
    otp_title_text: "",
    otp_title_color: "#000000",
    edit_text_color: "#BE2330",
    resend_text_color: "#BE2330",
    desktop_bg_image: "",
    mobile_bg_image: "",
    existing_user_desktop_image: "",
    existing_user_mobile_image: "",
    existing_user_title: "",
    existing_user_description: "",
    existing_user_title_color: "#000000",
    existing_user_description_color: "#666666",
    brochure_desktop_image: "",
    brochure_mobile_image: "",
    brochure_title: "",
    brochure_description: "",
    brochure_title_color: "#000000",
    brochure_description_color: "#666666",
    brochure_link_color: "#BE2330",
    new_user_desktop_image: "",
    new_user_mobile_image: "",
    new_user_title: "",
    new_user_description: "",
    new_user_title_color: "#000000",
    new_user_description_color: "#666666",
    popup_display_interval_1: "",
    popup_display_interval_2: "",
    popup_display_interval_3: "",
    enable_delay_form: false,
    enable_exit_form: false,
    /** ERP (internal) vs LSQ (Upgrad drop-lead) — lead drop variant 4 API */
    lead_integration_destination: "erp",
  },

  LEAD_DROP_POPUP_FIELDS_CONFIG: [
    {
      fieldName: "form_title",
      label: "Form Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Form Title",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "form_title_color",
      label: "Form Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Form Title Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "form_sub_text",
      label: "Form Sub Text",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Form Sub Text",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "form_sub_text_color",
      label: "Form Sub Text Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Form Sub Text Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "checkbox_description",
      label: "Checkbox Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Checkbox Description",
      required: false,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "checkbox_description_color",
      label: "Checkbox Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Checkbox Description Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "checkbox_color",
      label: "Checkbox Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Checkbox Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Text Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "signup_button_text",
      label: "Signup Button Text",
      value: "Sign Up",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Signup Button Text",
      required: false,
      defaultValue: "Sign Up",
    },
    {
      fieldName: "signup_icon",
      label: "Signup Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Signup Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "otp_title_text",
      label: "OTP Title Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter OTP Title Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "otp_title_color",
      label: "OTP Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Title Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "edit_text_color",
      label: "Edit Text Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Edit Text Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "resend_text_color",
      label: "Resend Text Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Resend Text Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Desktop Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "bg_image_alt",
      label: "Background Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for background image",
      required: false,
      defaultValue: "Form background",
    },
    {
      fieldName: "existing_user_desktop_image",
      label: "Existing User Desktop Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Existing User Desktop Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "existing_user_mobile_image",
      label: "Existing User Mobile Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Existing User Mobile Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "existing_user_image_alt",
      label: "Existing User Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for existing user image",
      required: false,
      defaultValue: "Existing user",
    },
    {
      fieldName: "existing_user_title",
      label: "Existing User Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Existing User Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "existing_user_description",
      label: "Existing User Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Existing User Description",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "existing_user_title_color",
      label: "Existing User Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Existing User Title Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "existing_user_description_color",
      label: "Existing User Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Existing User Description Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "brochure_desktop_image",
      label: "Brochure Desktop Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Brochure Desktop Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "brochure_mobile_image",
      label: "Brochure Mobile Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Brochure Mobile Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "brochure_image_alt",
      label: "Brochure Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for brochure image",
      required: false,
      defaultValue: "Brochure download",
    },
    {
      fieldName: "brochure_title",
      label: "Brochure Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Brochure Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "brochure_description",
      label: "Brochure Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Brochure Description",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "brochure_title_color",
      label: "Brochure Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Brochure Title Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "brochure_description_color",
      label: "Brochure Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Brochure Description Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "brochure_link_color",
      label: "Brochure Link Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Brochure Link Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "new_user_desktop_image",
      label: "New User Desktop Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload New User Desktop Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "new_user_mobile_image",
      label: "New User Mobile Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload New User Mobile Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "new_user_image_alt",
      label: "New User Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for new user image",
      required: false,
      defaultValue: "New user",
    },
    {
      fieldName: "new_user_title",
      label: "New User Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter New User Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "new_user_description",
      label: "New User Description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter New User Description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "new_user_title_color",
      label: "New User Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter New User Title Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "new_user_description_color",
      label: "New User Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter New User Description Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "popup_display_interval_1",
      label: "Popup Display Interval 1",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Popup Display Interval 1 (e.g., 3000 - for 3 seconds)",
      required: false,
      defaultValue: "",
      validation: (value: any, formData: Record<string, any>) => {
        if (formData?.enable_delay_form && (!value || value.toString().trim() === "")) {
          return "Popup Display Interval 1 is required when Enable Delay Form is checked";
        }
        return null;
      },
    },
    {
      fieldName: "popup_display_interval_2",
      label: "Popup Display Interval 2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Popup Display Interval 2 (e.g., 6000 - for 6 seconds)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "popup_display_interval_3",
      label: "Popup Display Interval 3",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Popup Display Interval 3 (e.g., 12000 - for 12 seconds)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "enable_delay_form",
      label: "Enable Delay Form",
      value: false,
      valueType: "boolean",
      filedType: "CHECKBOX",
      placeholder: "Enable form to show after delay",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "enable_exit_form",
      label: "Enable Exit Form",
      value: false,
      valueType: "boolean",
      filedType: "CHECKBOX",
      placeholder: "Enable form to show on exit intent",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "lead_integration_destination",
      label: "Lead destination (Drop 4)",
      value: "erp",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Where to send the lead after OTP",
      required: true,
      defaultValue: "erp",
      /** Persist in JSON — not a DB column on lead_drop_popup; Sequelize would drop a top-level key. */
      isJsonField: true,
      options: [
        { label: "ERP", value: "erp" },
        { label: "LSQ (Upgrad)", value: "lsq" },
      ],
    },
  ],

  METADATA_FIELDS: [],
};

